import axios, { AxiosPromise } from "axios";
import { IClientListParams, IClosingSettleParam, IExpenseListParams, IGetCashFlowExpense, IGetCashFlowIncome, IGetCashFlowPnL, IGetClientList, IGetClosingInEx, IGetClosingSettle, IGetClosingSettleAccount, IGetDateClosing, IGetExpense, IGetExpenseAlarmList, IGetExpenseDetailList, IGetExpenseLine, IGetExpenseList, IGetIncome, IGetIncomeList, IGetPnLException, IGetStudentIncome, IGetTotalAmount, IIncomeListParams, IPnLUpdateValue } from "../models/financials.model";
import QueryString from "qs";
import { IGetEmployees } from "../models/financials.model";

const uri = '/mgmt/financials';

//수입
export const getIncomes = (params: IIncomeListParams): AxiosPromise<IGetIncomeList> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/income?${qsParams}`);
}
  
export const getIncome = (incomeCode: number, commonCode: string): AxiosPromise<IGetIncome> => {
    return axios.get(`${uri}/income/${incomeCode}?treeCommonCode=` + commonCode);
}

export const getIncomeTotalAmount = (params: IIncomeListParams): AxiosPromise<IGetTotalAmount> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/income/total-amount?${qsParams}`);
}
  
export const createIncome = (data: FormData): AxiosPromise => {
    return axios.post(uri + '/income', data);
};

export const updateIncome = (incomeCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/income/${incomeCode}`, data);
};

export const deleteAdminIncome = (incomeCode: number): AxiosPromise => {
    return axios.delete(`${uri}/income/admin/${incomeCode}`);
}

//지출
export const getExpenses = (params: IExpenseListParams): AxiosPromise<IGetExpenseList> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/expense?${qsParams}`);
}
  
export const getExpense = (expenseCode: number, commonCode: string): AxiosPromise<IGetExpense> => {
    return axios.get(`${uri}/expense/${expenseCode}?treeCommonCode=` + commonCode);
}

export const getExpenseDetailList = (data: FormData): AxiosPromise<IGetExpenseDetailList> => {
    return axios.post(`${uri}/expense/detail-list`, data);
}

export const getExpenseAlarmList = (): AxiosPromise<IGetExpenseAlarmList> => {
    return axios.get(`${uri}/expense/alarm-list`);
}

export const getExpenseTotalAmount = (params: IExpenseListParams): AxiosPromise<IGetTotalAmount> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/expense/total-amount?${qsParams}`);
}

export const createExpense = (data: FormData): AxiosPromise => {
    return axios.post(uri + '/expense', data);
};

export const updateExpense = (expenseCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/${expenseCode}`, data);
};

export const updateExpenseAmount = (expenseCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/${expenseCode}/amount`, data);
};

export const updateExpenseReApproval = (expenseCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/re-approval/${expenseCode}`, data);
};

export const updateApprovalStatus = (expenseCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/approval/status/${expenseCode}`, data);
};

export const deleteExpense = (expenseCode: number): AxiosPromise => {
    return axios.delete(`${uri}/expense/${expenseCode}`);
};

export const deleteAdminExpense = (expenseCode: number): AxiosPromise => {
    return axios.delete(`${uri}/expense/admin/${expenseCode}`);
};

//거래처
export const getClients = (params: IClientListParams): AxiosPromise<IGetClientList> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/expense/client?${qsParams}`);
}

export const createClient = (data: FormData): AxiosPromise => {
    return axios.post(uri + '/expense/client', data);
};

export const updateClient = (clientCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/client/${clientCode}`, data);
};

//결재라인 직원검색
export const getEmployees = (params: any): AxiosPromise<IGetEmployees> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/expense/approval/employees?${qsParams}`);
}

//결재라인
export const getApprovalLine = (expenseCode: number): AxiosPromise<IGetExpenseLine> => {
    return axios.get(`${uri}/expense/approval/line/${expenseCode}`);
}

//마지막결재라인
export const getApprovalLastLine = (campusCode: string): AxiosPromise<IGetExpenseLine> => {
    return axios.get(`${uri}/expense/approval/line/last/${campusCode}`);
}

//지출 결재
export const getExpenseApproval = (params: IExpenseListParams): AxiosPromise<IGetExpenseList> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/expense-approval?${qsParams}`);
}

export const updateApproval = (expenseCode: number, data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/approval/${expenseCode}`, data);
};

export const updateMultiApproval = (data: FormData): AxiosPromise => {
    return axios.put(`${uri}/expense/approval/multiApproval`, data);
};

//수입지출
//학생수입정보
export const getStudentIncomes = (params: FormData): AxiosPromise<IGetStudentIncome> => {
    //const qsParams = QueryString.stringify(params);
    return axios.post(`${uri}/income-expense/student-income`, params);
}

//현금흐름표
//수입(캠퍼스)
export const getCashFlowIncomesCampus = (params: FormData): AxiosPromise<IGetCashFlowIncome> => {
    return axios.post(`${uri}/cashflow/income-campus`, params);
}

//수입(본사)
export const getCashFlowIncomesHq = (params: FormData): AxiosPromise<IGetCashFlowIncome> => {
    return axios.post(`${uri}/cashflow/income-hq`, params);
}

//지출내역
export const getCashFlowExpense = (params: FormData): AxiosPromise<IGetCashFlowExpense> => {
    return axios.post(`${uri}/cashflow/expense`, params);
}

//손익
export const getCashFlowPnL = (params: FormData): AxiosPromise<IGetCashFlowPnL> => {
    return axios.post(`${uri}/cashflow/pnl`, params);
}

//손익제외금액
export const getPnLException = (year:string, campusCode:string): AxiosPromise<IGetPnLException> => {
    return axios.get(`${uri}/expense/exception?year=${year}&campusCodes=${campusCode}`);
}

export const updatePnLException = (data: any): AxiosPromise => {
    return axios.put(`${uri}/expense/exception`, data, {headers: {
        "Content-Type": "application/json",
    }});
};

//마감 일자별 목록
export const getClosingDates = (year:string, month:string, campusCode:string): AxiosPromise<IGetDateClosing> => {
    return axios.get(`${uri}/closing/dates?year=${year}&month=${month}&campusCodes=${campusCode}`);
}

//마감 수입
export const getClosingIncomes = (params: IIncomeListParams): AxiosPromise<IGetClosingInEx> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/closing/income?${qsParams}`);
}

//마감 지출
export const getClosingExpenses = (params: IExpenseListParams): AxiosPromise<IGetClosingInEx> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/closing/expense?${qsParams}`);
}

//마감 입출금 현황
export const getClosingSettle = (srtDate:string, campusCode:string): AxiosPromise<IGetClosingSettle> => {
    return axios.get(`${uri}/closing/settle?srtDate=${srtDate}&campusCodes=${campusCode}`);
}

//마감 입출금 잔고 현황
export const getClosingSettleAccount = (srtDate:string, campusCode:string): AxiosPromise<IGetClosingSettleAccount> => {
    return axios.get(`${uri}/closing/settle-account?srtDate=${srtDate}&campusCodes=${campusCode}`);
}

//마감 입출금 저장
export const createClosingSettle = (params: IClosingSettleParam): AxiosPromise => {
    return axios.post(`${uri}/closing/settle`, params, {headers: {
        "Content-Type": "application/json",
    }});
}

//마감 취소
export const updateClosingCancle = (params: FormData): AxiosPromise => {
    return axios.put(`${uri}/closing/cancel`, params);
}
